import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Coins } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0B0E14] px-6">
      <div className="w-full max-w-sm fade-up">
        <div className="mb-8 flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-md border border-[#F0B90B]/30 bg-[#F0B90B]/10">
            <Coins className="h-4 w-4 text-[#F0B90B]" />
          </div>
          <div className="font-heading text-sm font-bold tracking-widest text-[#EAECEF]">
            AUREUS <span className="text-[#F0B90B]">GOLD FUND</span>
          </div>
        </div>
        <h1 className="font-heading text-2xl font-bold tracking-tight text-[#EAECEF]">Reset your password</h1>
        <p className="mt-2 text-sm text-[#848E9C]">Enter your account email and we'll send you a reset link.</p>
        {done ? (
          <div data-testid="forgot-confirmation-message" className="mt-6 rounded-md border border-[#0ECB81]/40 bg-[#0ECB81]/10 px-4 py-3 text-sm text-[#0ECB81]">
            If that email is registered, a reset link has been sent.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            {error && (
              <div data-testid="forgot-error-message" className="rounded-md border border-[#F6465D]/40 bg-[#F6465D]/10 px-3 py-2 text-sm text-[#F6465D]">
                {error}
              </div>
            )}
            <input
              data-testid="forgot-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com"
              className="w-full rounded-md border border-[#2A2E39] bg-[#1E222D] px-3 py-2.5 text-sm text-[#EAECEF] placeholder:text-[#5E6673] focus:border-[#F0B90B]/50 focus:outline-none"
            />
            <button
              data-testid="forgot-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full rounded-md bg-[#F0B90B] py-2.5 text-sm font-semibold text-black shadow-[0_0_12px_rgba(240,185,11,0.25)] transition-colors hover:bg-[#F8D12F] disabled:opacity-50"
            >
              {loading ? "Sending..." : "Send Reset Link"}
            </button>
          </form>
        )}
        <div className="mt-6 text-center">
          <Link to="/login" data-testid="back-to-login-link" className="text-xs text-[#848E9C] transition-colors hover:text-[#F0B90B]">
            Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
